import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getStyles } from './code-snippet-styles';

const CodeSnippetUnstyled = (props) => {
  const {
    classes,
    className,
    model,
    codeTemplate,
  } = props;

  return (
    <div
      className={classNames(className, classes.codeSnippetContainer, 'code-snippet')}
      role="region"
      aria-label={props['aria-label']}
      translate="no"
    >
      <ReactTemplate
        model={model}
        template={codeTemplate || ''}
      />
    </div>
  );
};

CodeSnippetUnstyled.propTypes = {
  'aria-label': PropTypes.string,
  classes: PropTypes.shape({
    codeSnippetContainer: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
  codeTemplate: PropTypes.string,
  model: PropTypes.shape({}),
};

CodeSnippetUnstyled.defaultProps = {
  'aria-label': undefined,
  className: undefined,
  codeTemplate: undefined,
  model: {},
};

export const CodeSnippet = withDefaultStyles(CodeSnippetUnstyled, getStyles);
